import React, { Component } from 'react';
import Lottie from 'react-lottie';

import styles from "components/Host/CountdownStyles.module.scss";

import countdownPinkSides from "images/Host/Countdown/COUNTDOWN_Pink_Column.png";
import countdownBlueSides from "images/Host/Countdown/COUNTDOWN_Blue_Column.png";
import countdownWhiteSides from "images/Host/Countdown/COUNTDOWN_White_Column.png";

import segmentLine from "images/Host/Countdown/Segment Line 2.png";
import posMarker from "images/Host/Countdown/PosMarker.png";
import scoreBubble from "images/Host/Countdown/Column_Score_Container.png";
import wrongScoreBubble from "images/Host/Countdown/Wrong_bubble.png";
import flares from "images/Host/Countdown/Vertical_Flare_Sprite.png";
import purpleFlash from "images/Host/Countdown/purpleFlash.png";

export default class Countdown extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
      
    }

    renderCountdown() {
        let lines = [];

        for (let i = 1; i <= 100; i++) {
            lines.push(
                //<div className={`${styles.line} ${this.props.countdownValue < i && styles.fade}`} name={`line-${i}`}></div>
                <img className={`${styles.line} ${this.props.countdownValue < i && styles.basicFade}`} name={`line-${i}`} src={segmentLine} />
                //<img className={`${styles.line} ${this.props.countdownValue < i && (this.props.optimise ? styles.basicFade : styles.fade)}`} name={`line-${i}`} src={segmentLine} />
                //<svg width="100%" height="20" viewBox="0 0 100 20" preserveAspectRatio="none">
                //    <path d="M0,10 Q50,15 100,10" stroke="white" stroke-width="2" fill="none" />
                //</svg>
            );
        }

        return lines;
    }

    getFlarePosition() {
        let threshold = 0.8;

        let base = -10;
        let change = (100 - this.props.countdownValue) * threshold;
        change = base + change;

        return `${change}%`
    }

    getPurpleFlashPos() {
        let base = 50;
        let amount = this.props.countdownValue - base;

        return `${amount}%`;
    }

    render() {
        console.log("Countdown Value : ")
        return (
            <div className={`${styles.countdown} ${this.props.type === "mainRound" ? styles.mainRound : styles.finalRound}`}>
                <div className={styles.countdownColumn}>
                 
                    {/*<div className={`${styles.scoreBubble} ${this.props.wrongAnswer ? styles.flipped : ""} ${this.props.countdownFinished && styles.finished}`}>*/}
                        <div className={`${styles.scoreBubble} ${this.props.countdownFinished && styles.finished}`}>
                        <div className={styles.inner}>
                            <div className={`${styles.face} ${styles.front}`}>
                                <img src={scoreBubble} className={styles.bubble} alt="score" />
                                <span>{this.props.countdownValue}</span>
                            </div>

                            {/*<div className={`${styles.face} ${styles.back}`}>*/}
                            {/*    <img src={wrongScoreBubble} className={styles.bubble} alt="wrong score" />*/}
                            {/*</div>*/}
                        </div>
                    </div>
                    <div className={styles.lineSection}>
                        <img src={purpleFlash} className={`${styles.purpleFlash} ${styles.hide} ${this.props.countdownFinished && styles.purpleFlashAnim}`} style={{ bottom: this.getPurpleFlashPos() }} />
                        {this.props.countdownFinished && <img className={`${styles.line} ${styles.marker}`} style={{ top: `${100 - this.props.countdownValue}%` }} src={posMarker} />}
                        <img src={flares} className={styles.flares} style={{ bottom: this.getFlarePosition() }} />

                        {
                            this.renderCountdown()
                        }
                    </div>
                </div>
            </div>
        )
    }
}